import React, { Component } from 'react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router'

import '../styles/App.less';
import 'bootstrap/less/bootstrap.less';
import HeroHeader from './HeroHeader';
import Content from  './Content';
import Footer from  './Footer';

import Offer from  './Offer';
import Home from  './Home';
import About from  './About';
import Contact from  './Contact';
import Events from  './Events';
import News from  './News';
import Pricing from  './Pricing';

class App extends Component {
  render() {
    return (
      <div className="App">
        <HeroHeader/>
          <Router history={browserHistory}>
              <Route path="/" component={Content}>
                  <IndexRoute component={Home} />
                  <Route path="/about" component={About} />
                  <Route path="/contact" component={Contact}/>
                  <Route path="/pricing" component={Pricing}/>
                  <Route path="/events" component={Events}/>
                  <Route path="/news" component={News}/>
                  <Route path="*" component={Home} />
              </Route>
          </Router>
        <Footer/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js